<head>
	<!-- Stylesheets -->
	<link href="https://cdn.jsdelivr.net/npm/daisyui@2.24.0/dist/full.css" rel="stylesheet" type="text/css" />
	<script src="https://cdn.tailwindcss.com"></script>

</head>

<svelte:head>

	<title>Calculate Height</title>

	<meta name="robots" content="noindex nofollow" />
	<meta name="viewport" content="width=device-width, initial-scale=1.0">
	<meta name="keywords" content="Trignometry, Mathematics, Clinometer, Height, Side, Height of Building, Aggregate, Data, TheOnlyWayUp">

	<meta property="og:title" content="Calculate Height | TheOnlyWayUp">
	<meta property="og:type" content="website">

	<meta name="og:description" content="Helps you calculate the height of an object using Trignometry.">
	<meta name="theme-color" content="#668899">
	<meta name="description" content="Helps you calculate the height of an object using Trignometry.">
	<meta charset="utf-8">

	<!-- <meta property="og:image" content="./images/embed_image.png"> -->

</svelte:head>

<script>
    import Header from "./Header.svelte";
    import Information from "./Information.svelte";
    import Reading from "./ClinoReadings/Reading.svelte";
    import Footer from "./Footer.svelte";

    import ThemeStore from "./stores.js";

    export let HTMLParent;

</script>


<Header Parent={HTMLParent} />
<Information />
<Reading />
<Footer />

